import { nullable, number, optional } from "@/api/analytics/utils/Cubestruct";
import { billingFocusSchema } from "@ternary/api-lib/analytics/schemas/billingFOCUS";

export const DatabaseSpendSummaryStruct = {
  cost: nullable(number()),
};

export const CostSpendSummaryStruct = {
  cost: nullable(number()),
};

export const KubernetesSpendSummaryStruct = {
  cost: nullable(number()),
};

export const StorageSpendSummaryStruct = {
  [billingFocusSchema.measures.billedCost.schemaName]: optional(
    nullable(number())
  ),
};
